module.exports = __webpack_public_path__ + "img/1.2355e531.png";